function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { HeadingText } from './elements';
export const Heading = ({
  ...props
}) => /*#__PURE__*/React.createElement(HeadingText, _extends({
  $desktopSize: props.size ?? 7,
  $mobileSize: props.size ?? 5,
  $textWrap: "balance",
  size: "unset",
  weight: "heavy"
}, props));